<template>
  <div
    class="title mr-3 ml-3"
    >
    {{text}}
  </div>
</template>
<script>
  export default {
    props: ['text']
  }
</script>
